const base = '/developer'
const foreignRoutes = {
  api: {
    upload_img: '/applications/uploads/store_image',
  },
}
const routeGetters = {
  routeApiFrn: state => url => base + state.api[url],
}
export default {
  state: foreignRoutes,
  getters: routeGetters,
}
